<template>
  <div>
    <table-h-scroll :has-sticky="true" :sticky-styles="stickyStyles"
                    :sticky-datas="stickyDatas" :reload-controls="loading && sentItems.length">
      <table v-show="!loading && sentItems.length"
             class="table is-fullwidth is-first-fixed-small is-last-fixed-small is-marginless-bottom is-narrow is-striped-v is-marginless-bottom has-actionsontd">
        <thead>
        <tr class="is-size-6">
          <th>
            Titre
          </th>
          <th>
            Note
          </th>
          <th v-if="isAdmin || isSectorManager">
            Auteur
          </th>
          <th>
            Date
          </th>
          <th class="has-text-centered is-narrow">Actions</th>
        </tr>
        </thead>
        <tbody>
          <tr v-for="(c, i) in sentItems" :key="c.pk" class="is-size-6">
            <td class="is-narrow">{{c.title}}</td>
            <td><span v-if="c.note">{{c.note}}</span><span v-else>-</span></td>
            <td class="is-narrow" v-if="isAdmin || isSectorManager"><router-link :to="{name: 'UserVue', params: {id: c.author}}">{{c.author_name || '-' | smallName}}</router-link></td>
            <td class="is-narrow">{{c.date | prettyDatetime}}</td>
            <td class="has-text-centered actions">
              <display-button-list :forceDropDown="true" :buttons="buttonList" :data="c"
                                 :openUp="{'position': i, 'total': sentItems.length}">
              </display-button-list>
              <!-- <button class="button is-circle is-small" @click="deleteItem(c.pk)">
                <i class="fal fa-trash"></i>
              </button> -->
            </td>
          </tr>
        </tbody>
      </table>
    </table-h-scroll>
    <div v-show="!loading && !sentItems.length" class="is-border-top">
      <div class="columns">
        <div class="column">
          <h2 class="title is-3 has-text-weight-bold">Aucun rappel programmé</h2>
        </div>
      </div>
    </div>
    <div class="is-border-top" v-if="totalPage > 1 && nextPage && !loading">
      <a class="button is-light is-fullwidth has-text-grey" @click="loadMore(true)" v-if="!infiniteLoading">
        <span class="icon is-small is-size-6"><i class="fas fa-chevron-down"></i></span>
        <span class="is-size-6">Afficher la suite</span>
      </a>
      <div class="has-text-centered" v-else><img src="static/spinner2.svg" alt="spinner" style="height: 38px"></div>
    </div>
  </div>
</template>

<script>
  import { Sort, ColumnConf, TableHeaderSticky } from '@/mixins'
  import { mapState, mapGetters } from 'vuex'
  import moment from 'moment'
  
  export default {
    name: 'CalendarListReminder',
    mixins: [Sort, ColumnConf, TableHeaderSticky],
    props: {
      sentItems: Array,
      loading: Boolean,
      totalPage: Number,
      nextPage: Number
    },
    data () {
      return {
        buttonList: [
          {
            action: (id, data) => {
              console.log(data)
              let day = moment(data.date).format('DD')
              let month = moment(data.date).format('MM')
              let year = moment(data.date).format('YYYY')
              this.$router.push({ name: 'CalendarDayView', query: { day, month, year, returnId: data.pk, panel: 'REMINDERS' } })
            },
            icon: 'fa-eye',
            text: 'Voir'
          },
          {
            action: (id, data) => {
              let params = {
                source: data
              }
              this.$store.commit('setQuickview', {mode: 'EDIT_REMINDER', params: params})
            },
            icon: 'fa-edit',
            text: 'Editer'
          },
          {
            action: (id, data) => {
              this.deleteItem(id, data)
            },
            icon: 'fa-trash',
            text: 'Supprimer'
          }
        ],
        sortBy: {}
      }
    },
    computed: {
      ...mapState(['scrollToEl', 'scrollToPage']),
      ...mapGetters(['currentUserPk', 'isAdmin', 'isSectorManager', 'isManager', 'isOperator', 'isSeller']),
      columnsShow () {
        const columns = {
          'guest': { label: 'Invité(s)', mobile: true },
          'author': { label: 'Organisateur', mobile: true }
        }
        return columns
      }
    },
    methods: {
      loadMore (val) {
        this.$emit('loadMore', val)
      },
      deleteItem (i) {
        this.$emit('deleteItem', i)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/calendar/CalendarListReminder.vue